module.exports = __webpack_public_path__ + "static/media/BS_O_Embroidery_Bicocca_White_Black.01c14514.png";